import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-currency',
  imports: [FormlyModule, MatInputModule, MatFormFieldModule, ReactiveFormsModule],
  template: `
    <mat-form-field
      [hideRequiredMarker]="true"
      [floatLabel]="field.props.floatLabel"
      [appearance]="field.props.appearance"
      [color]="field.props.color"
      [style.width]="'100%'"
    >
      @if (field.props?.label && field.props?.hideLabel !== true) {
        <mat-label>
          {{ field.props.label }}
          @if (field.props?.required && field.props?.hideRequiredMarker !== true) {
            <span class="mat-form-field-required-marker">*</span>
          }
        </mat-label>
      }
      <input
        matInput
        [id]="id"
        type="number"
        [formControl]="formControl"
        [readonly]="field.props.readonly"
        [formlyAttributes]="field"
        [tabindex]="field.props.tabindex || 0"
        [placeholder]="field.props.label ?? ''"
      />
      @if (field.props?.currency) {
        <span matTextSuffix>{{ field.props.currency }}</span>
      }
      <mat-error>
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>

      @if (field.props?.description) {
        <mat-hint>{{ field.props.description }}</mat-hint>
      }
    </mat-form-field>
  `,
})
export class FormlyCurrencyComponent extends FieldType<FieldTypeConfig> {}
